import { Suspense, lazy, Fragment } from "react";
import { Route, Routes } from "react-router-dom";
import MainLayout from "./layouts/Main";
import ManageLayout from "./layouts/Manage";
import { jsx as _jsx } from "react/jsx-runtime";
export const routes = [{ path: "/",
        element: /*#__PURE__*/ lazy(() => import("./views/404")), layout: ManageLayout },
    //   path: "/home",
    //   element: lazy(() => import("./views/home")),
    //   layout: ManageLayout,
    // },
    // {
    //   path: "/login",
    //   element: lazy(() => import("./views/login")),
    //   layout: ManageLayout,
    // },
    // {
    //   path: "/manage",
    //   element: lazy(() => import("./views/manage")),
    //   layout: ManageLayout,
    // },
    { path: "/host/:id", element: /*#__PURE__*/ lazy(() => import("./views/host")), layout: MainLayout }, { path: "/guest/:id", element: /*#__PURE__*/ lazy(() => import("./views/guest")), layout: MainLayout }, { path: "/self/:id", element: /*#__PURE__*/ lazy(() => import("./views/selfStudy")), layout: MainLayout }, { path: "/nomobile", element: /*#__PURE__*/ lazy(() => import("./views/NoMobile")), layout: MainLayout }, { path: "*", element: /*#__PURE__*/ lazy(() => import("./views/404")), layout: MainLayout }];
export function AppRouter(_ref) { let {} = _ref; return /*#__PURE__*/ _jsx(Suspense, { fallback: /*#__PURE__*/ _jsx("div", { children: "Loading..." }), children: /*#__PURE__*/ _jsx(Routes, { children: routes.map((route, i) => { const Guard = Fragment; const Layout = route.layout || Fragment; const Element = route.element; return /*#__PURE__*/ _jsx(Route, { path: route.path, element: /*#__PURE__*/ _jsx(Guard, { children: /*#__PURE__*/ _jsx(Layout, { children: /*#__PURE__*/ _jsx(Element, {}) }) }) }, i); }) }) }); }
